const formatPriceToFloat = (price: Price): number => parseFloat(String(price).replace(' ', '').replace(',', '.'));

export default formatPriceToFloat;
